import { Permissions } from './permissions';

export const ORGANIZATION_TYPE_CUSTOMER = 'customer';
export const ORGANIZATION_TYPE_MSP = 'msp';
export const ORGANIZATION_TYPE_RESELLER = 'reseller';
export const ORGANIZATION_TYPE_RESELLER_MSP = 'reseller_msp';

export const RESELLER_LIKE = [
    ORGANIZATION_TYPE_RESELLER,
    ORGANIZATION_TYPE_RESELLER_MSP,
];

export function findMainOrganizationRole(user) {
    if (user && user.organizations && user.organizations.length) {
        return user.organizations[0].type;
    }
    return 'unknown';
}
function hasPaymentChangeAccess(user) {
    return user.canChange(Permissions.ACCOUNT_DETAILS_PAYMENT_METHOD);
}

function hasMethodSetup(user) {
    const [organization] = user && user.organizations;
    return !!(organization && organization.payment_method_setup);
}

export function isPaymentMethodSetup(user) {
    if (user) {
        if (hasPaymentChangeAccess(user)) {
            return hasMethodSetup(user);
        }
    }
    return true;
}

export const isResellerLike = user => {
    const role = findMainOrganizationRole(user);
    return RESELLER_LIKE.includes(role);
};

export const isOrganizationAdmin = user => {
    if (user && user.organizations && user.organizations.length) {
        return !!user.organizations[0].is_admin;
    }
    return false;
};

export const isPartnerPortalEligible = organization =>
    !!(organization && organization.has_partner_portal_eligible_subscription);
